import { Card } from "react-bootstrap";

export default Card;
